import BubbleChartViz from '../vizs/BubbleChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display three or four dimensions of data. Each entity of associated data is plotted as a bubble that expresses two of the values through the bubble’s xy location and the third through its size.
 * 
 * Bubble charts can be considered a variation of the scatter plot, in which the data points are replaced with bubbles.
 * 
 * ### Example Usage
 * ```javascript
 *   import {BubbleChart} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new BubbleChart($el, data, config);
 *   
 * ```
 * 
 * This chart can be considered as an extension of a [ScatterPlot](#/developer/ScatterPlotComponent), with an additional variable mapped into the bubble size
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 5 columns. Each row represents a bubble, and the first column should be the id/label, then its X and Y postion, its group (for colors) and its size.
 *  
 * | ID       |     X  |    Y  |  Group   |   Size    |
 * | -------- | ------ |-------|----------|-----------|
 * |   a      |    22.4|   22.4|  Group 1 |   2.30    |
 * |   b      |    52.3|   12.5|  Group 2 |   2.45    |
 * |   c      |    12.8|   52.2|  Group 1 |   4.10    |
 * |   d      |    13.3|   12.6|  Group 2 |   5.12    |
 * 
 * {.data-table}
 *
 */
export default class BubbleChartComponent extends BaseComponent {
  static componentLabel = "Bubble chart"
  static vizClass = BubbleChartViz
  static dataFormat = [
    {index:0,axis:'',label:'id',types:[String],role:'id',roleLabel:'Item'},
    {index:1,axis:'x0',label:'x value',types:[Number,Date],role:'value',roleLabel:'X value - Number or Date (dd-mm-yyyy)'},
    {index:2,axis:'y0',label:'x value',types:[Number,Date],role:'value',roleLabel:'Y value - Number or Date (dd-mm-yyyy)'},
    {index:3,axis:'',label:'color',types:[String],role:'value',roleLabel:'Category/Color'},
    {index:4,axis:'',label:'size',types:[Number],role:'value',roleLabel:'Size value'},
  ]
  static defaultConfig = {
    title: this.componentLabel,
  }
}